import { render, staticRenderFns } from "./MenuListingsSectionModule.vue?vue&type=template&id=0beb04e2&"
import script from "./MenuListingsSectionModule.vue?vue&type=script&lang=js&"
export * from "./MenuListingsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports